import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { Panel } from "@/admin/ui";

const RANGES = [[7, "7 days"], [30, "30 days"], [0, "All time"]];

export const AreaDemandPanel = () => {
  const [days, setDays] = useState(30);
  const [rows, setRows] = useState(null);
  useEffect(() => { adminApi.get("/area-demand", { params: { days } }).then((r) => setRows(r.data)); }, [days]);

  return (
    <Panel title="Area demand · unserved searches" className="mt-6" testId="area-demand-panel" action={
      <div className="flex gap-1">
        {RANGES.map(([d, l]) => (
          <button key={d} onClick={() => setDays(d)} data-testid={`area-demand-range-${d}`}
            className={`h-7 px-2.5 rounded text-xs font-semibold transition-colors ${days === d ? "bg-primary text-white" : "text-primary hover:bg-stone-100"}`}>{l}</button>
        ))}
      </div>}>
      <p className="text-xs text-stone-500 mb-3">Pincodes and areas customers searched that you don't deliver to. Repeat searches from the same browser count once a day.</p>
      {rows && rows.length === 0 && <p className="text-sm text-stone-500" data-testid="area-demand-empty">No unserved searches in this period.</p>}
      <div className="divide-y divide-stone-100">
        {rows?.map((r) => (
          <div key={r.key} className="flex items-center gap-3 py-2 text-sm" data-testid={`area-demand-row-${r.key.replace(/\s+/g, "-")}`}>
            <span className="font-semibold text-primary mr-auto">{r.query}</span>
            <span className="text-xs text-stone-500">last {new Date(r.last).toLocaleDateString("en-IN")}</span>
            {r.waiting > 0 && <span className="text-xs font-bold text-accent" data-testid={`area-demand-waiting-${r.key.replace(/\s+/g, "-")}`}>{r.waiting} waiting</span>}
            <span className="w-12 text-right font-extrabold">{r.count}</span>
          </div>
        ))}
      </div>
    </Panel>
  );
};
